module.exports = __webpack_public_path__ + "img/PSKOV.205adfd0.png";